import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import HTML5Backend from "react-dnd-html5-backend";
import { DragDropContext } from "react-dnd";
import update from "immutability-helper";

import {
  updateRuleOrderAndExecuteRules,
  deleteAndExecuteRule,
  updateRuleActiveState
} from "../../../store/actions/rule.actions";
import GlobalRuleListItemContainer from "./globalRuleListItem.component";
import DefineRuleContainer from "./defineRule.container";
import { List, ListItem, IconButton, Typography } from "@material-ui/core";
import CopyIcon from '@material-ui/icons/FileCopy';
import { copyRulesToClipboard } from "../../../helpers/clipboard.helper";
import { addMessage } from "../../../store/actions/message.actions";
class GlobalRuleListContainer extends React.Component {
  constructor(props) {
    super(props);

    this.moveRule = this.moveRule.bind(this);
    this.dropRule = this.dropRule.bind(this);
    this.renderRuleListItems = this.renderRuleListItems.bind(this);
    this.copyGlobalRulesToClipboard = this.copyGlobalRulesToClipboard.bind(this);

    this.state = {
      rules: _.values(this.props.rules).sort((a, b) => a.index - b.index)
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.setState({
        rules: _.values(this.props.rules).sort((a, b) => a.index - b.index)
      });
    }
  }

  copyGlobalRulesToClipboard() {
    const copySucces = copyRulesToClipboard(this.state.rules);
    copySucces
      ? addMessage('success', 'Copied the rules to your clipboard!')
      : addMessage('error', 'Something went wrong copying the rules to your clipboard');
  }
  moveRule(dragIndex, hoverIndex) {
    const { rules } = this.state;
    const dragRule = rules[dragIndex];

    this.setState(
      update(this.state, {
        rules: {
          $splice: [[dragIndex, 1], [hoverIndex, 0, dragRule]]
        }
      })
    );
  }

  dropRule() {
    this.props.updateRuleOrderAndExecuteRules(this.state.rules);
  }

  renderRuleListItems() {
    return _.map(this.state.rules, (rule, index) => (
      <GlobalRuleListItemContainer
        key={rule.id}
        index={index}
        rule={rule}
        moveRule={this.moveRule}
        deleteRule={this.props.deleteAndExecuteRule}
        updateRuleActive={this.props.updateRuleActiveState}
        dropRule={this.dropRule}
      />
    ));
  }

  render() {
    const { rules } = this.state;

    return (
      <React.Fragment>
        <div style={{ padding: '25px 25px 0 25px', display: 'flex', flexDirection: 'row' }}>
          <Typography variant="h4" gutterBottom>Global Rules</Typography>
          <div style={{ marginLeft: 'auto' }}>
            <DefineRuleContainer isGlobal={true} />
          </div>
          <IconButton
            style={{ margin: '10px 0 0 10px', height: 'min-content' }}
            aria-label="Copy"
            onClick={this.copyGlobalRulesToClipboard}
          >
            <CopyIcon />
          </IconButton>
        </div>
        <List>
          <ListItem style={{ display: _.size(rules) > 0 ? "none" : "block" }}>
            <Typography>No global rules defined</Typography>
          </ListItem>
          {this.renderRuleListItems()}
        </List>
      </React.Fragment>
    );
  }
}

GlobalRuleListContainer.propTypes = {
  rules: PropTypes.shape({
    id: PropTypes.number,
    text: PropTypes.string,
    index: PropTypes.number
  }).isRequired,
  updateRuleOrderAndExecuteRules: PropTypes.func.isRequired,
  updateRuleActiveState: PropTypes.func.isRequired,
  deleteAndExecuteRule: PropTypes.func.isRequired
};

export default DragDropContext(HTML5Backend)(
  connect(
    null,
    { updateRuleOrderAndExecuteRules, deleteAndExecuteRule, addMessage, updateRuleActiveState }
  )(GlobalRuleListContainer)
);
